import { ReportResponseDtoStatus } from '@api/WhisApi/generated';
import { ReportStatus } from '@components/ReportList/reportList.types';
import i18n from '@store/i18n';
import { capitalizeFirstLetter } from '@utils/capitalizeFirstLetter';
import { appConfig as tamaguiConfig } from 'tamagui.config';

const statusTranslationKeys: Record<ReportResponseDtoStatus, string> = {
  [ReportResponseDtoStatus.published]: 'filters.options.status.published',
  [ReportResponseDtoStatus.pendingRRA]: 'filters.options.status.pendingRra',
  [ReportResponseDtoStatus.publishedRRA]: 'filters.options.status.publishedRra',
  [ReportResponseDtoStatus.draft]: 'filters.options.status.draft',
  [ReportResponseDtoStatus.incorrect]: 'filters.options.status.incorrect',
};

const statusColors: Record<ReportResponseDtoStatus, string> = {
  [ReportResponseDtoStatus.publishedRRA]:
    tamaguiConfig.tokens?.color?.successFont?.val ?? '#116610',
  [ReportResponseDtoStatus.published]:
    tamaguiConfig.tokens?.color?.successFont?.val ?? '#116610',
  [ReportResponseDtoStatus.pendingRRA]:
    tamaguiConfig.tokens?.color?.warningFont?.val ?? '#FF4815',
  [ReportResponseDtoStatus.incorrect]:
    tamaguiConfig.tokens?.color?.error?.val ?? '#F93B34',
  [ReportResponseDtoStatus.draft]:
    tamaguiConfig.tokens?.color?.secondary50?.val ?? 'rgba(39, 40, 42, 0.5)',
};

export function getStatusText(status: ReportResponseDtoStatus): string {
  const translationKey = statusTranslationKeys[status];
  return translationKey ? i18n.t(translationKey) : capitalizeFirstLetter(status);
}

export default function getStatusTextAndColor(
  status: ReportResponseDtoStatus,
): ReportStatus {
  return {
    text: getStatusText(status),
    color:
      statusColors[status] ??
      (tamaguiConfig.tokens?.color?.secondary50?.val ??
        'rgba(39, 40, 42, 0.5)'),
  };
}
